import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useSpdCore } from '../../../common/hooks/useSpdCore';

export const CardPreviewLink = (props: { cardId: string }) => {
  const spd = useSpdCore();

  const handleClick = () => {
    spd.pdfPrinter
      .loadAndPrintCard(props.cardId)
      .catch(error =>
        console.log(`Wystąpił problem z wydrukiem karty. ${error}`),
      );
  };

  return (
    <>
      <OverlayTrigger overlay={<Tooltip>Wydruk</Tooltip>}>
        <Button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          variant="btn-info"
        >
          <Icon.Printer />
        </Button>
      </OverlayTrigger>
    </>
  );
};
